import React from "react";
import { Filter } from "chq";

type FilterGroupProps = {
  group: [Filter];
  prefix: string;
  orRelation?: boolean;
};

export const getTitle = (group: [Filter], prefix: string) => {
  if (!group?.length) {
    return "";
  }

  let text = ` ${prefix} `;
  group.forEach((element, index) => {
    switch (index) {
      case (group.length - 2):
        text += `${element?.name || element}`;
        break;
      case (group.length - 1):
        text += ` and ${element?.name || element}`;
        break;
      default:
        text += `${element?.name || element}, `;
        break;
    }
  });

  return text;
};

const FilterGroup: React.FC<FilterGroupProps> = ({ group, prefix, orRelation = false }) => {
  if (!group?.length) {
    return null;
  }

  return (
    <>
      {" "}
      {prefix}
      {" "}
      {group.map((element, index) => {
        if (index === group.length - 1) {
          return (<strong key={index}>{element?.name || element}</strong>);
        }

        if (index === group.length - 2) {
          return (
            <>
              <strong>{element?.name || element}</strong>
              {orRelation ? " or " : " and "}
            </>
          );
        }

        return (
          <>
            <strong>{element?.name || element}</strong>
            {", "}
          </>
        );
      })}
    </>
  );
};

export default FilterGroup;
